module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Sélectionnez le texte des compétences techniques dans le CV original.","resetAllIndents":"Réaligner toutes les indentations en bulletpoints de niveau 1"},"en":{"a":"Select the text about technical skills from the original CV.","resetAllIndents":"Re-align all the indents into level 1 bulletpoints"}}')
  delete Component.options._Ctor
}
